import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { EMS_STATUS, DISPATCH_NOTE, redLightAvailability } from '../data/availability';

const Hero = () => {
  const scrollToSection = (selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 grid-background"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[800px] h-[800px] bg-blue-500/20 rounded-full blur-3xl animate-pulse-slow"></div>
      </div>

      <div aria-hidden="true" className="hidden lg:flex absolute inset-0 items-center justify-between px-8 xl:px-16 pointer-events-none z-[5]">
        <span className="efam-flank-text">EF</span>
        <span className="efam-flank-text">AM</span>
      </div>

      <div aria-hidden="true" className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-24 pointer-events-none z-[4]">
        <svg viewBox="0 0 1200 100" preserveAspectRatio="none" className="w-full h-full">
          <polyline
            className="heartbeat-line"
            fill="none"
            stroke="#1E90FF"
            strokeWidth="2"
            points="0,50 150,50 175,20 200,80 225,50 400,50 430,10 455,90 480,50 700,50 730,25 755,75 780,50 1000,50 1030,15 1055,85 1080,50 1200,50"
          />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10 pt-24 pb-16">
        <div className="max-w-5xl mx-auto text-center">
          <div className="space-y-8 animate-fadeIn">
            <div className="space-y-5">
              <p className="text-sm md:text-base font-bold tracking-[0.28em] text-cyan-400">
                FORGED FOR PURPOSE &middot; BUILT FROM PRESSURE
              </p>
              <h1 className="text-5xl md:text-7xl font-bold leading-tight" data-testid="hero-headline">
                <span className="text-white">COMMERCIAL EMS</span>
                <br />
                <span className="text-cyan-400 neon-text">BODY SCULPTING SYSTEMS</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                High-intensity electromagnetic muscle stimulation for people rebuilding strength with a smarter path forward&mdash;supplied worldwide with direct Australian support.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold rounded-full px-8 py-6 glow-button"
                onClick={() => scrollToSection('#packages')}
                data-testid="hero-shop-ems"
              >
                Shop EMS Systems
                <ArrowRight className="ml-2" size={19} />
              </Button>
              <Button
                variant="outline"
                className="border-red-400 text-red-300 hover:bg-red-500/10 rounded-full px-8 py-6"
                onClick={() => scrollToSection('#red-light')}
                data-testid="hero-red-light"
              >
                Red Light &mdash; {redLightAvailability.label}
                <Zap className="ml-2" size={19} />
              </Button>
            </div>

            <a
              href="/full-range"
              className="inline-flex items-center text-sm font-semibold text-gray-300 hover:text-cyan-400"
            >
              View the complete EMS range
              <ArrowRight className="ml-2" size={16} />
            </a>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-8 justify-center pt-5 text-sm text-gray-400">
              <div className="flex items-center justify-center gap-2">
                <span className="text-cyan-400">&#10003;</span>
                <span>EMS systems &mdash; {EMS_STATUS.toLowerCase()}</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-cyan-400">&#10003;</span>
                <span>{DISPATCH_NOTE}</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-red-400">&#8226;</span>
                <span>Red light &mdash; {redLightAvailability.label.toLowerCase()}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
